import { createContext, useContext } from "react";

export interface AccordionContextType {
  /** True when the item at `index` should render its expanded detail content. */
  shouldExpandDetails: (index: number) => boolean;
  /** Position of the current item inside the flattened accordion. */
  itemIndex: number;
  arrowDirection?: "right" | "down";
  highlightExpandedItem?: boolean;
}

export const AccordionContext = createContext<AccordionContextType | undefined>(
  undefined,
);

/**
 * Read the accordion context provided by the parent `Builder:Accordion` block.
 * Throws if an AccordionItem / AccordionTitle / AccordionDetail block is
 * authored outside of a parent Accordion (Builder's `childRequirements`
 * normally prevents this, but the guard keeps the failure loud in dev).
 */
export const useAccordionContext = (): AccordionContextType => {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error(
      "useAccordionContext must be used within an AccordionProvider. Ensure all accordion-related blocks are nested within 'Builder:Accordion'.",
    );
  }
  return context;
};
